(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["FAQ"]) return;
  try {
       
$(document).on("shopify:section:load",'#shopify-section-FAQ',function(e){

});          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Favicon-and-Scrollbar"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Favicon-and-Scrollbar',function(e){

 $('body').addClass('editing editfavicon');

     $(document).on("shopify:section:deselect",'#shopify-section-Favicon-and-Scrollbar',function(e){
        $('body').removeClass('editfavicon');
      
     });   
}); 
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header-Notification"]) return;
  try {
    
 $(document).on("shopify:section:select",'#shopify-section-Header-Notification',function(e){
 $('body').addClass('editing editnotification').trigger( "updatelayout" );
     $(document).on("shopify:section:deselect",'#shopify-section-Header-Notification',function(e){
        $('body').removeClass('editnotification').trigger( "updatelayout" );
     });   
});               

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header-with-Bottom-Menu"]) return;
  try {
         
$(document).on("shopify:section:load",'#shopify-section-Header',function(e){
$( "[data-role = 'navbar']" ).navbar();
$( "#searchPopup" ).enhanceWithin().popup();
});                   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header"]) return;
  try {
         

$(document).on("shopify:section:load",'#shopify-section-Header',function(e){
 $( "[data-role = 'navbar']" ).navbar();
 $( "#searchPopup" ).enhanceWithin().popup();
});            

$(document).on("shopify:section:select",'#shopify-section-Header',function(e){
$('body').addClass('editing editheader');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editheader');
})

});   



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Loader"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Loader',function(e){
 $('body').addClass('editing editloader');
     $(document).on("shopify:section:deselect",'#shopify-section-Loader',function(e){
        $('body').removeClass('editloader');
     });   
});   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Mobile-Menu"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Mobile-Menu',function(e){
 paneledit();
 $('body').addClass('editing editpanel');

     $(document).on("shopify:section:deselect",'#shopify-section-Mobile-Menu',function(e){
        $('body').removeClass('editpanel');
        paneledit();
     });   
}); 

function paneledit() {
    $("#shopify-section-Mobile-Menu").panel({
      close: function(event, ui) {
        $('#swiper_Frame').removeClass('popup-open');
       stopBodyScrolling(false); 
      },
      open: function(event,ui) {
             var vpH = window.innerHeight;  
      $('#swiper_Frame').addClass('popup-open');
document.documentElement.style.height = vpH.toString() + "px";
$('#swiper_Frame')[0].style.height = vpH.toString() + "px";
stopBodyScrolling(true); 
      }
      
    });
}                

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Popup"]) return;
  try {
    
 $(document).on("shopify:section:select",'#shopify-section-Popup',function(e){
$([document.documentElement, document.body]).animate({ scrollTop: 0 }); 
 popupedit();
 $('body').addClass('editing editpopup');

   




     $(document).on("shopify:section:deselect",'#shopify-section-Popup',function(e){
        $('body').removeClass('editpopup');
        $( "#mailPopup" ).popup( "close");
     });   
}); 

  

  
function popupedit() {
     console.log('test5');
      $( "#mailPopup" ).popup( "open", {
       transition: "slideupfade",
        y: 100,
      }); 
}                                                                  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Product-FAQ"]) return;
  try {
       
$(document).on("shopify:section:load",'#shopify-section-Product-FAQ',function(e){
    var accordion = $(this).find('[data-role="accordion"]');
    accordion.accordion();
});          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Stories"]) return;
  try {
    
$(document).one("shopify:section:select",'#shopify-section-Stories',function(e){


var myElement = $('#shopify-section-Stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });     
}else{
$('body').animate({ scrollTop: topPos }); 
}    

$(document).one("shopify:section:deselect",'#shopify-section-Stories',function(e){                           
      
                           
$(document).one("shopify:section:select",'#shopify-section-Stories',function(e){
var myElement = $('#shopify-section-Stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('body').animate({ scrollTop: topPos });  
}    
});                       
                           
                           
                           
});
});  
$(document).on("shopify:section:select",'#shopify-section-Stories',function(e){
story();
setTimeout(function() { 
scrollswiper(); 
},200);  
$('body').addClass('editing editstories');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editstories');
})

});   
              

  } catch(e) { console.error(e); }
})();

})();
